module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fc-Gd-Ha-Ia.f9fb5410.png";